function addClassIfNotOnTop(element, className) {
  const handleScroll = () => {
    if (window.pageYOffset > 0) {
      element.classList.add(className);
    } else {
      element.classList.remove(className);
    }
  };

  window.addEventListener('scroll', handleScroll);

  // Call handleScroll once to set initial class
  handleScroll();

  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}
